import type { FC } from "react";

import { RadioButton, type RadioButtonProps } from "@jti/core-components";

import type { PointsRangeItemDefinition } from "./PointsRange.types";

export type PointsRangeItemProps = PointsRangeItemDefinition & {
  checked: boolean;
  onChecked: () => void;
};

export const PointsRangeItem: FC<PointsRangeItemProps> = ({ value, displayName, checked, onChecked }) => {
  const onChange: RadioButtonProps["onChange"] = (event) => {
    if (event.target.checked) {
      onChecked();
    }
  };

  return <RadioButton label={displayName} value={value} checked={checked} onChange={onChange}></RadioButton>;
};
